import {useEffect, useState} from 'react';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {apiGet, handleApiError} from '../api';

export default function AvvisiPage() {
    const [articoli, setArticoli] = useState(null); // null = in caricamento

    useEffect(() => {
        apiGet('/bolle-codici-mancanti')
            .then((data) => setArticoli(data ?? []))
            .catch(handleApiError);
    }, []);

    return (
        <Layout>
            <Titolo indietro>Avvisi</Titolo>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Articoli in transito non presenti in Passepartout</h5>
                    {articoli === null && <Caricamento/>}
                    {articoli?.length === 0 && <Vuoto>Nessun articolo da mostrare.</Vuoto>}
                    {articoli?.length > 0 && (
                        <table className="table table-hover mb-0">
                            <thead>
                            <tr>
                                <th>Codice</th>
                                <th>Articolo</th>
                            </tr>
                            </thead>
                            <tbody>
                            {articoli.map((a, i) => (
                                <tr key={i}>
                                    <td className="font-monospace">{a.codice}</td>
                                    <td>{a.descrizione}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </Layout>
    );
}
